<template>
    <Modal :mask-closable="true" v-model="show" title="安全验证" :footer-hide="true" :scrollable="false"
        class-name="QHImgopen" :width="330">
        <slide-verify ref="slideblock" @again="onAgain" @fulfilled="onFulfilled" @success="onSuccess" @fail="onFail"
            @refresh="onRefresh" :accuracy="accuracy" :imgs="imgs" slider-text="向右滑动填充拼图"></slide-verify>
    </Modal>
</template>

<script>

export default {
    name: 'QHslideverify',
    data() {
        return {
            show: false,
            accuracy: 2,
            imgs: [
                require('./img/a1.png'),
                require('./img/a2.png'),
                require('./img/a3.png'),
                require('./img/a4.png'),
                require('./img/a5.png'),
                require('./img/a6.png'),
                require('./img/a7.png'),
                require('./img/a8.png'),
                require('./img/a9.png'),
                require('./img/a10.png'),
                require('./img/a11.png'),
                require('./img/a12.png')
            ],
        };
    },
    methods: {
        // 验证通过
        onSuccess(times) {
            this.show = false;
            this.$msg("验证通过,用时" + times + "ms", "success");
            this.$emit("success");
            this.$refs.slideblock.reset();
        },
        // 验证失败
        onFail() {
            this.$msg("验证不通过,请重新验证", "error");
        },
        // 滑块上的刷新
        onRefresh() {

        },
        // 刷新后执行的回调函数
        onFulfilled() {
        },
        // 检测是否人为操作
        onAgain() {
            this.$msg("验证不通过,请重新验证", "error");
            this.$refs.slideblock.reset();
        },
        // 重置刷新
        handleClick() {
            this.$refs.slideblock.reset();
        }
    }
}
</script>

<style>
#slideVerify .slide-verify-slider-mask-item {
    height: 38px !important;
}
</style>
